import { render, staticRenderFns } from "./OTPChangeEmail.vue?vue&type=template&id=4f6c1348"
import script from "./OTPChangeEmail.vue?vue&type=script&lang=js"
export * from "./OTPChangeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports